import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable, tap, throwError } from 'rxjs';
import { environment } from '@/environments/environment';
import { LoadingService } from '@/app/core/loading/loading.service';
import { SesionUsuario } from './auth.models';
import { ContextoTenantStore } from './contexto-tenant.store';

@Injectable({ providedIn: 'root' })
export class SesionService {
    private readonly http = inject(HttpClient);
    private readonly contexto = inject(ContextoTenantStore);
    private readonly loading = inject(LoadingService);
    private cargaActual: Promise<SesionUsuario> | null = null;

    cargar(forzar = false): Promise<SesionUsuario> {
        const actual = this.contexto.sesion();
        if (actual && !forzar) return Promise.resolve(actual);
        this.cargaActual ??= this.loading
            .trackPromise(
                firstValueFrom(this.http.get<SesionUsuario>(`${environment.apiUrl}/sesion`)).then((sesion) => {
                    this.contexto.establecer(sesion);
                    return sesion;
                }),
                'blocking'
            )
            .finally(() => (this.cargaActual = null));
        return this.cargaActual;
    }

    limpiar(): void {
        this.contexto.limpiar();
    }

    guardarAvatar(avatar: string): Observable<{ avatar: string }> {
        const sesion = this.contexto.sesion();
        if (!sesion) return throwError(() => new Error('La sesión venció. Vuelve a iniciar sesión.'));
        return this.http.put<{ avatar: string }>(`${environment.apiUrl}/sesion/avatar`, { avatar }).pipe(
            tap((respuesta) => {
                // Una respuesta pendiente nunca debe restaurar una sesión cerrada o reemplazada.
                if (this.contexto.sesion() === sesion) {
                    this.contexto.establecer({ ...sesion, avatar: respuesta.avatar });
                }
            })
        );
    }
}
